<div class="informationals-page-item" *ngFor="let block of blocks; trackBy: trackByFn;" [innerHTML]="block" commonAutoATags></div>
